/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendlabel2Inputs */

const en_actionendlabel2 = /** @type {(inputs: Actionendlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid until`)
};

const de_actionendlabel2 = /** @type {(inputs: Actionendlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gilt bis`)
};

/**
* | output |
* | --- |
* | "Valid until" |
*
* @param {Actionendlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendlabel2 = /** @type {((inputs?: Actionendlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendlabel2(inputs)
	return de_actionendlabel2(inputs)
});
export { actionendlabel2 as "actionEndLabel" }